import { useEffect } from 'react';

import { updateMessagesInViewport } from 'APP/Tasks/messaging/updateMessagesInViewport/updateMessagesInViewport';
import Entities from 'STORE';

export function useUpdateMessagesInViewportHandlerPresenter(): void {
  useEffect(() => {
    updateMessagesInViewport();
  }, [Entities.viewportMessages.viewportMessages]);
}
